/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query AdminAccountRead {
    AdminAccountRead {
      email
      id
      level
      name
      brandname
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
